export enum SectionType {
  Support = 'support',
  Privacy = 'privacy',
  Terms = 'terms',
  ChildSafety = 'childSafety',
  BlockedUsers = 'blocked-users',
  DeleteData = 'deleteData'
}
